export default __webpack_public_path__ + "76c60088954f43469d7c709672b57b26.png";